import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./ActivityPercentage.css";

function ActivityPercentage({ activityPercentage }) {
  const getClassName = (activityPercentage) => {
    if (activityPercentage >= 70) {
      return "activityPercentageAbove70";
    }
    if (activityPercentage > 40) {
      return "activityPercentageAbove40";
    }
    return "avtivityPercntageBelow40";
  };
  return (
    <span>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="button-tooltip-2">
            {`Activity Percentage ${activityPercentage}`}
          </Tooltip>
        }
      >
        {({ ref, ...triggerHandler }) => {
          return (
            <span {...triggerHandler}>
              <span ref={ref}>
                <span className={getClassName(activityPercentage)}>
                  {activityPercentage} %
                </span>
              </span>
            </span>
          );
        }}
      </OverlayTrigger>
    </span>
  );
}

export default ActivityPercentage;
